import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  AddressInput,
  Button,
  CheckboxInput,
  FormButtons,
  TextInput,
  Title,
  FormError,
  PortalForm
} from '@portal/kit/pkg/components'

export default function AuthenticationForm({ form, offer, handleSubmit, globalError, submitError }) {
  const { t } = useTranslation()

  return (
    <PortalForm onSubmit={handleSubmit}>
      {
        (globalError || submitError) && <FormError message={globalError || submitError} />
      }
      <>
        <Title>{t('portal.offers.authentication_title')}</Title>
        <TextInput name="first_name" label={t('registrations.first_name')} form={form} />
        <TextInput name="last_name" label={t('registrations.last_name')} form={form} />
        <TextInput name="email" label={t('registrations.email')} form={form} />
        <AddressInput name="address" form={form} />
        <CheckboxInput name="newsletter" label={t('registrations.newsletter')} />
      </>

      <FormButtons>
        <Button classType="cancel" to={`/offers/${offer.id}`}>{t('portal.offers.previous')}</Button>
        <Button type="submit">{t('portal.offers.validate')}</Button>
      </FormButtons>
    </PortalForm>
  )
}
